import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";

import { Route, Switch } from "react-router";

import { push } from "connected-react-router";

import queryString from "query-string";

import routes from "./routes";

import generateAction from "../utils/action-helpers";
import { USER } from "../state/actions";

import ErrorPage from "./ui/error";

import "bootstrap/dist/css/bootstrap.css";

import "../assets/css/fonts.scss";
import "../assets/css/icons-cepsa.css";
import "../assets/css/style.scss";

export default () => {
  const { role, error, loading } = useSelector(state => state.user.current);

  const dispatch = useDispatch();

  useEffect(() => {
    const hashParams = queryString.parse(window.location.hash);

    if (hashParams.error) {
      dispatch(generateAction(USER.LOGIN_ERROR));
    }

    if (hashParams.access_token) {
      window.localStorage.setItem("auth", hashParams.id_token);
      dispatch(push(window.localStorage.getItem("path")));
      window.localStorage.removeItem("path");
    }

    if (!error && !role && !loading) {
      const auth = window.localStorage.getItem("auth");
      dispatch(generateAction(USER.LOGIN, auth));
    }
  }, [role, error, loading, dispatch]);

  if (error)
    return (
      <ErrorPage
        title="Ha habido un error"
        subtitle="Oopps. Ha habido un error accediendo a los servicios"
        text="Recargue la página y si el error persiste contacte con el CSU"
        pages={[]}
      />
    );
  if (!role || loading) return <div />;

  return (
    <Switch>
      {routes.map(route => (
        <Route key={route.path} path={route.path} component={route.component} exact={route.exact} />
      ))}
    </Switch>
  );
};
